// removed by extract-text-webpack-plugin
module.exports = {"dev":"style__dev___1Iy6l"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/style.scss
// module id = 2226
// module chunks = 0